import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp'
import SupportAgentIcon from '@mui/icons-material/SupportAgent'
import { Divider, InputAdornment, InputLabel, Typography } from '@mui/material'
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion'
import MuiAccordionDetails from '@mui/material/AccordionDetails'
import MuiAccordionSummary, { AccordionSummaryProps } from '@mui/material/AccordionSummary'
import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'
import { Container } from '@mui/system'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'

import { IsItem } from '../../interfaces/IsItem'
import { Form, FormField, SubmitButton } from '../../shared/forms'
import FormSelect from '../../shared/forms/FormSelect'
interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

interface FormValues {
  type: string
  model: string
}

const initialValues: FormValues = { type: '', model: '' }

const validationSchema = Yup.object().shape({
  type: Yup.string().required().label('ResponseUnit'),
  model: Yup.string().required().label('YourQuestion'),
})

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div
      aria-labelledby={`simple-tab-${index}`}
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      role='tabpanel'
      {...other}
    >
      {value === index && <Box sx={{ m: 1 }}>{children}</Box>}
    </div>
  )
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}
const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  borderRadius: 5,
  marginBottom: 2,
  border: `1px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&:before': {
    display: 'none',
  },
}))

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, .05)' : 'rgba(0, 0, 0, .03)',
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
  },
}))

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  padding: theme.spacing(2),
  borderTop: '1px solid rgba(0, 0, 0, .125)',
}))

export default function TicketsScreen() {
  const [expanded, setExpanded] = React.useState<string | false>('panel1')

  const handleChangeAccordion =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false)
    }
  const [value, setValue] = React.useState(0)
  const { t } = useTranslation()

  const SupportTypes: IsItem[] = React.useMemo(
    () => [
      { id: '1', label: t('screens.tickets.support_select_placeholder'), value: '1' },
      { id: '2', label: t('screens.tickets.sale_select_placeholder'), value: '2' },
      { id: '3', label: t('screens.tickets.software_select_placeholder'), value: '3' },
      { id: '4', label: t('screens.tickets.hardware_select_placeholder'), value: '4' },
    ],
    [],
  )

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }

  return (
    <Container maxWidth='sm'>
      <Box display='flex' justifyContent='center' sx={{ mt: 2 }}>
        <img alt='Logo' src='images/TinyLogo.png' />
      </Box>
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs aria-label='basic tabs example' centered onChange={handleChange} value={value}>
            <Tab label={t('screens.tickets.response_ticket_tab_title')} {...a11yProps(0)} />
            <Tab
              label={t('screens.tickets.Frequently_asked_questions_tab_title')}
              {...a11yProps(1)}
            />
          </Tabs>
        </Box>
        <TabPanel index={0} value={value}>
          <Box sx={{ direction: 'rtl' }}>
            <Form
              initialValues={initialValues}
              onSubmit={(values) => {const mystr = ''}}
              validationSchema={validationSchema}
            >
              <InputLabel id='demo-controlled-open-select-label'>
                {t('screens.tickets.select_the_response_unit_label')}
              </InputLabel>
              <FormSelect
                endAdornment={
                  <InputAdornment position='start'>
                    <SupportAgentIcon />
                  </InputAdornment>
                }
                items={SupportTypes}
                name='type'
              />
              <FormField
                inputProps={{ maxLength: 8000 }}
                multiline
                name='model'
                placeholder={t('screens.tickets.question_input_placeholder')}
              />
              <SubmitButton fullWidth title={t('screens.tickets.send_button_text')} />
            </Form>
          </Box>
        </TabPanel>

        <TabPanel index={1} value={value}>
          <Accordion expanded={expanded === 'panel1'} onChange={handleChangeAccordion('panel1')}>
            <AccordionSummary aria-controls='panel1d-content' id='panel1d-header'>
              <Typography>Collapsible Group Item #1</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus
                ex, sit amet blandit leo lobortis eget. Lorem ipsum dolor sit amet, consectetur
                adipiscing elit. Suspendisse malesuada lacus ex, sit amet blandit leo lobortis eget.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion expanded={expanded === 'panel2'} onChange={handleChangeAccordion('panel2')}>
            <AccordionSummary aria-controls='panel2d-content' id='panel2d-header'>
              <Typography>Collapsible Group Item #2</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus
                ex, sit amet blandit leo lobortis eget. Lorem ipsum dolor sit amet, consectetur
                adipiscing elit. Suspendisse malesuada lacus ex, sit amet blandit leo lobortis eget.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion expanded={expanded === 'panel3'} onChange={handleChangeAccordion('panel3')}>
            <AccordionSummary aria-controls='panel3d-content' id='panel3d-header'>
              <Typography>Collapsible Group Item #3</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus
                ex, sit amet blandit leo lobortis eget. Lorem ipsum dolor sit amet, consectetur
                adipiscing elit. Suspendisse malesuada lacus ex, sit amet blandit leo lobortis eget.
              </Typography>
            </AccordionDetails>
          </Accordion>
        </TabPanel>
      </Box>
    </Container>
  )
}
